import { useCallback } from 'react';

export const useLocalStorage = () => {
    const setLocalStorageValue = useCallback((key: string, value: any) => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error('Error saving to localStorage:', error);
        }
    }, []);

    const getLocalStorageValue = useCallback(({key, deleteAfterGet = false}: {key: string, deleteAfterGet?: boolean}) => {
        try {
            const item = localStorage.getItem(key);
            if (!item) return null;

            const value = JSON.parse(item);

            // Delete if requested
            if (deleteAfterGet) {
                localStorage.removeItem(key);
            }

            return value;
        } catch (error) {
            console.error('Error reading from localStorage:', error);
            return null;
        }
    }, []);

    const deleteLocalStorageValue = useCallback((key: string) => {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error('Error deleting from localStorage:', error);
        }
    }, []);

    return { getLocalStorageValue, setLocalStorageValue, deleteLocalStorageValue };
};

